export const IMG_PATH = "/images/";
